import React from 'react';
import PropTypes from 'prop-types';

import useInput from '../../utils/common/customHook';

import {
  TITLE_CONFIRM_PASSWORD,
  TITLE_CONFIRM_PASSWORD_EN,
  TITLE_EMAIL,
  TITLE_EMAIL_EN,
  TITLE_NAME,
  TITLE_NAME_EN,
  TITLE_PASSWORD,
  TITLE_PASSWORD_EN,
  TITLE_REGISTER,
  TITLE_REGISTER_EN,
} from '../../utils/common/constant';
import { DivInputAuthentication, InputAuthentication, LabelAuthentication } from '../styled';

const RegisterInput = ({ register }) => {
  const [email, onEmailChange] = useInput('');
  const [name, onNameChange] = useInput('');
  const [password, onPasswordChange] = useInput('');
  const [confirmPassword, onConfirmPasswordChange] = useInput('');
  const locale = 'en';

  function onSubmitHandlerRegister() {
    if (password !== confirmPassword) {
      alert('password must be same with confirm password');
      return;
    }

    // eslint-disable-next-line consistent-return
    return register({
      name,
      email,
      password,
    });
  }

  return (
    <DivInputAuthentication>
      <LabelAuthentication htmlFor="name">{locale === 'id' ? TITLE_NAME : TITLE_NAME_EN}</LabelAuthentication>
      <InputAuthentication type="text" id="name" placeholder="Name" value={name} onChange={onNameChange} />

      <LabelAuthentication htmlFor="email">{locale === 'id' ? TITLE_EMAIL : TITLE_EMAIL_EN}</LabelAuthentication>
      <InputAuthentication type="email" id="email" placeholder="Email" value={email} onChange={onEmailChange} />

      <LabelAuthentication htmlFor="password">{locale === 'id' ? TITLE_PASSWORD : TITLE_PASSWORD_EN}</LabelAuthentication>
      <InputAuthentication type="password" id="password" placeholder="Password" value={password} onChange={onPasswordChange} />

      <LabelAuthentication htmlFor="password">{locale === 'id' ? TITLE_CONFIRM_PASSWORD : TITLE_CONFIRM_PASSWORD_EN}</LabelAuthentication>
      <InputAuthentication type="password" id="password" placeholder="ConfirmPassword" value={confirmPassword} onChange={onConfirmPasswordChange} />

      <button type="button" className="button-register" aria-label="register" onClick={onSubmitHandlerRegister}>{locale === 'id' ? TITLE_REGISTER : TITLE_REGISTER_EN}</button>
    </DivInputAuthentication>
  );
};

RegisterInput.propTypes = {
  register: PropTypes.func.isRequired,
};

export default RegisterInput;
